/**
 * MW Customizer — editor logic for sections/mw-product-customizer.liquid.
 * Gate 4: Fabric v6 canvas with template-derived geometry + overlay.
 * Fabric.js PINNED at v6.9.1, self-hosted at assets/fabric.min.js, loaded only
 * by the customizer section (see CLAUDE.md customizer exception). v6 API is
 * Promise-based — never mix v5 callback calls in here.
 *
 * Geometry rule: ALL print/case geometry derives from the template image's
 * natural dimensions (currently 2300x3900 = the exact print file spec).
 * Nothing print-related is hard-coded in JS.
 *
 * Config contract (shop.metafields.mw_customizer.config, json):
 *   { types: [{ slug, availability, variant_id, output_type,
 *       brands: [{ slug, availability, variant_id,
 *         models: [{ slug, availability, variant_id, template_url, mask_url }] }] }] }
 *   variant_id cascades: deepest non-null wins. availability:false at any
 *   level hides the node. template_url/mask_url may be bare theme-asset
 *   filenames (resolved against data-asset-base) or absolute URLs.
 */
(function () {
  'use strict';
  if (customElements.get('mw-customizer')) return;

  var log = function () {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[MW Customizer]');
    console.log.apply(console, args);
  };

  /* Text options. Families are self-hosted (snippets/mw-customizer-fonts.liquid);
     `tamil: true` marks the families with real Tamil glyph coverage. */
  var FONTS = [
    { label: 'Catamaran', css: 'MW Catamaran', weight: 700, tamil: true },
    { label: 'Mukta Malar', css: 'MW Mukta Malar', weight: 700, tamil: true },
    { label: 'Baloo Thambi', css: 'MW Baloo Thambi', weight: 700, tamil: true },
    { label: 'Bebas Neue', css: 'MW Bebas Neue', weight: 400, tamil: false },
    { label: 'Playfair', css: 'MW Playfair', weight: 700, tamil: false }
  ];

  var COLOURS = [
    '#ffffff', '#000000', '#e6b422', '#c0392b', '#e84393',
    '#2980b9', '#16a085', '#8e44ad', '#e67e22', '#7f8c8d'
  ];

  /* Preset styles: fill/stroke/shadow combinations applied on top of the
     chosen colour. `useColour` false means the preset owns the fill. */
  var STYLES = [
    { id: 'plain', label: 'Plain' },
    { id: 'outline', label: 'Outline', stroke: '#000000', strokeWidth: 0.055 },
    { id: 'white-edge', label: 'White edge', stroke: '#ffffff', strokeWidth: 0.055 },
    { id: 'shadow', label: 'Shadow', shadow: 'rgba(0,0,0,0.55) 0 4px 10px' },
    { id: 'glow', label: 'Glow', shadow: 'rgba(255,255,255,0.9) 0 0 14px' },
    { id: 'lift', label: 'Lift', stroke: '#000000', strokeWidth: 0.035, shadow: 'rgba(0,0,0,0.5) 0 6px 12px' },
    { id: 'wide', label: 'Wide', charSpacing: 260 },
    { id: 'tight', label: 'Tight', charSpacing: -40 }
  ];

  var TEXT_MAX_CHARS = 40;
  var TEXT_MAX_LINES = 3;

  /* While something is selected the case mockup ghosts back so the customer
     can see the parts of their design that fall outside the printed area.
     The reference implementation uses 0.25, but its case art is translucent
     to begin with; ours has an opaque surround, so 0.25 washes the case out
     entirely. 0.45 shows the overhang while keeping the case readable. */
  var GHOST_OPACITY = 0.45;

  /* Above this, the raw original is re-encoded before upload (see
     _originalForUpload) so a huge DSLR file can't stall or fail checkout. */
  var MAX_ORIGINAL_BYTES = 10 * 1024 * 1024;

  var TAMIL_RE = /[஀-௿]/;

  /* Tamil letters are multiple code units (வ + ண + ் = one letter to a
     reader). Counting/slicing by code unit would give Tamil customers ~2/3
     the allowance and could cut a letter apart, so count graphemes. */
  var segmenter = (typeof Intl !== 'undefined' && Intl.Segmenter)
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    : null;

  var graphemes = function (str) {
    if (!segmenter) return Array.from(str);
    var out = [];
    var it = segmenter.segment(str)[Symbol.iterator]();
    for (var s = it.next(); !s.done; s = it.next()) out.push(s.value.segment);
    return out;
  };

  var countGraphemes = function (str) { return graphemes(str).length; };

  var sliceGraphemes = function (str, max) {
    var g = graphemes(str);
    return g.length <= max ? str : g.slice(0, max).join('');
  };

  class MWCustomizer extends HTMLElement {
    connectedCallback() {
      // The theme editor (and any DOM move) can reconnect the same instance;
      // a second init would append a duplicate canvas into the stage.
      if (this._connectedOnce) {
        log('reconnect ignored (already initialized)');
        return;
      }
      this._connectedOnce = true;
      this._statusEl = this.querySelector('[data-mw-cz-status]');
      this._stageEl = this.querySelector('[data-mw-cz-stage]');
      this._loadingEl = this.querySelector('[data-mw-cz-loading]');
      try {
        this._init();
      } catch (err) {
        log('init failed', err);
        this._fail('Could not start the customizer. Please refresh the page.');
      }
    }

    _init() {
      var cfgEl = this.querySelector('[data-mw-cz-config]');
      var config = null;
      try {
        config = cfgEl ? JSON.parse(cfgEl.textContent) : null;
      } catch (err) {
        log('config JSON parse error', err);
      }
      if (!config || !Array.isArray(config.types)) {
        return this._fail('The customizer is not configured yet.');
      }

      var node = this._resolvePath(config, this.dataset.configPath || '');
      if (!node) {
        return this._fail('This model is currently unavailable for customization.');
      }

      var variantInput = this.querySelector('[data-mw-cz-variant]');
      if (node.variant_id && variantInput &&
          String(node.variant_id) !== String(variantInput.value)) {
        // Config and product disagree; the product on this page is authoritative,
        // but flag it loudly because it means the config is stale.
        log('WARNING: config variant_id', node.variant_id,
          '!= product variant', variantInput.value, '- using product variant');
      }

      node.template_src = this._resolveUrl(node.template_url);
      node.mask_src = this._resolveUrl(node.mask_url);
      node.mockup_src = this._resolveUrl(node.mockup_url);
      if (!node.mockup_src) {
        return this._fail('Customizer template missing. Please try again later.');
      }

      this.czConfig = node;
      this._initCanvas(node);
    }

    /** Walks type/brand/model by slug, cascading variant_id and output_type. */
    _resolvePath(config, pathStr) {
      var path = pathStr.split('/').filter(Boolean);
      if (path.length !== 3) { log('bad config_path', pathStr); return null; }
      var norm = function (s) {
        return String(s || '').toLowerCase().trim().replace(/\s+/g, '_');
      };
      var find = function (list, slug) {
        if (!Array.isArray(list)) return null;
        for (var i = 0; i < list.length; i++) {
          if (norm(list[i].slug) === norm(slug)) return list[i];
        }
        return null;
      };
      var type = find(config.types, path[0]);
      if (!type || type.availability === false) return null;
      var brand = find(type.brands, path[1]);
      if (!brand || brand.availability === false) return null;
      var model = find(brand.models, path[2]);
      if (!model || model.availability === false) return null;

      return {
        type_title: type.title,
        brand_title: brand.title,
        model_title: model.title,
        output_type: model.output_type || brand.output_type || type.output_type || 'jpg',
        print_dpi: model.print_dpi || brand.print_dpi || type.print_dpi || 300,
        variant_id: model.variant_id || brand.variant_id || type.variant_id || null,
        template_url: model.template_url,
        mask_url: model.mask_url,
        mockup_url: model.mockup_url,
        // Where the printable artwork sits inside the mockup image, as
        // fractions of the mockup. Print dimensions derive from this.
        mockup_art_rect: model.mockup_art_rect
      };
    }

    _resolveUrl(url) {
      if (!url) return null;
      // Absolute AND protocol-relative (//cdn.shopify.com/...) pass through.
      if (/^(https?:)?\/\//.test(url)) return url;
      // Prefer the Liquid-built map: those URLs carry asset_url's ?v= hash,
      // so re-pushed assets are never served stale from CDN cache.
      var map = this._assetMap();
      if (map && map[url]) return map[url];
      return (this.dataset.assetBase || '') + url;
    }

    _assetMap() {
      if (this._assetMapCache !== undefined) return this._assetMapCache;
      var el = this.querySelector('[data-mw-cz-assets]');
      try {
        this._assetMapCache = el ? JSON.parse(el.textContent) : null;
      } catch (err) {
        log('asset map parse failed', err);
        this._assetMapCache = null;
      }
      return this._assetMapCache;
    }

    /** Fabric v6 canvas: sized from the stage box, aspect + export geometry
     *  derived from the template image's natural dimensions. */
    _initCanvas(node) {
      var self = this;
      if (!window.fabric || !window.fabric.Canvas) {
        log('fabric global missing');
        return this._fail('Could not load the editor. Please refresh the page.');
      }

      // The mockup IS the case (bezel, camera, gloss, opaque white surround)
      // with the print window punched transparent — authored from the PSD.
      // Print geometry derives from it plus the artwork rect: nothing about
      // the case or the print area is hard-coded here.
      var rect = node.mockup_art_rect || { x0: 0, y0: 0, x1: 1, y1: 1 };
      window.fabric.FabricImage.fromURL(node.mockup_src, { crossOrigin: 'anonymous' })
        .then(function (mockupImg) {
          self._mockupW = mockupImg.width;
          self._mockupH = mockupImg.height;
          self._artRect = rect;
          self._templateW = Math.round(mockupImg.width * (rect.x1 - rect.x0));
          self._templateH = Math.round(mockupImg.height * (rect.y1 - rect.y0));
          return self._whenStageMeasurable().then(function () {
            self._buildCanvas(mockupImg);
          });
        })
        .catch(function (err) {
          log('mockup load failed', node.mockup_src, err);
          self._fail('Could not load the case template. Please refresh.');
        });
    }

    /** Stage may measure 0 while CSS applies or while the tab is hidden.
     *  Ticks on setTimeout, NOT requestAnimationFrame — rAF is suspended in
     *  hidden/backgrounded tabs, which would stall the build forever even
     *  after layout becomes valid. Waits up to ~30s, then resolves anyway
     *  (the resize-factor guard makes a 0-size build recoverable). */
    _whenStageMeasurable() {
      var self = this;
      return new Promise(function (resolve) {
        var tries = 0;
        (function check() {
          if (self._destroyed) return resolve();
          if (self._stageEl.clientHeight > 100 || tries > 500) return resolve();
          tries += 1;
          setTimeout(check, 60);
        })();
      });
    }

    /** The canvas = artwork area + a workspace gutter on all sides. The
     *  gutter is where selection handles live (a cover-fit photo's corners
     *  sit exactly on the artwork bounds — without a gutter they'd be
     *  unreachable). Artwork aspect always derives from the template. */
    _gutterFor(artH) {
      return Math.round(Math.min(64, Math.max(36, artH * 0.085)));
    }

    /** Content is clipped to the artwork region so nothing spills into the
     *  handle gutter (a cover-fit photo usually overflows one axis). */
    _artClip() {
      var art = this._art;
      return new window.fabric.Rect({
        left: art.x, top: art.y, width: art.w, height: art.h,
        absolutePositioned: true
      });
    }

    /** Scales/positions the mockup so its artwork rect lands exactly on the
     *  canvas artwork region — the case then sits where it really is
     *  relative to the print area, at the PSD's true proportions. */
    _positionMockup() {
      var ov = this._mockupObj;
      var art = this._art;
      var r = this._artRect;
      if (!ov || !art || !r) return;
      var fullW = art.w / (r.x1 - r.x0);
      var fullH = art.h / (r.y1 - r.y0);
      ov.set({
        left: art.x - r.x0 * fullW,
        top: art.y - r.y0 * fullH,
        scaleX: fullW / this._mockupW,
        scaleY: fullH / this._mockupH
      });
    }

    /** The stage box holds the whole canvas (case + gutter). Sizing it in JS
     *  keeps the case at its intended size instead of the gutter eating into
     *  a CSS-fixed height. */
    _syncStageBox(dims) {
      this._stageEl.style.width = dims.w + 'px';
      this._stageEl.style.height = dims.h + 'px';
    }

    /** Print dimensions reduced to their smallest whole-number ratio
     *  (2300x3900 -> 23:39). Sizing the artwork region in exact multiples of
     *  this ratio keeps the on-screen aspect EXACTLY equal to the print
     *  aspect, so the export multiplier lands on whole print pixels instead
     *  of drifting a few pixels short. */
    _printRatio() {
      if (this._ratioCache) return this._ratioCache;
      var a = this._templateW, b = this._templateH, t;
      while (b) { t = b; b = a % b; a = t; }
      var d = a || 1;
      this._ratioCache = { rw: this._templateW / d, rh: this._templateH / d };
      return this._ratioCache;
    }

    /** The CASE is the thing being sized — the gutter is added AROUND it, so
     *  adding the workspace never shrinks the case. Target case height comes
     *  from the viewport (same scale as the approved idle look); width is
     *  constrained by the column. Artwork aspect always from the template. */
    _computeCanvasSize() {
      var wrap = this._stageEl.parentElement || this._stageEl;
      var r = this._printRatio();
      var targetH = Math.min(window.innerHeight * 0.74, 736);
      var k = Math.max(4, Math.round(targetH / r.rh));
      var artW = r.rw * k;
      var artH = r.rh * k;
      var g = this._gutterFor(artH);

      var availW = Math.min(
        (wrap.clientWidth || artW + 2 * g),
        Math.round(window.innerWidth * 0.94)
      );
      // Shrink in whole ratio steps so the aspect stays exact.
      var guard = 0;
      while (artW + 2 * g > availW && availW > 0 && k > 4 && guard < 200) {
        k -= 1;
        artW = r.rw * k;
        artH = r.rh * k;
        g = this._gutterFor(artH);
        guard += 1;
      }
      return { w: artW + 2 * g, h: artH + 2 * g, artW: artW, artH: artH, g: g };
    }

    /** Exact print multiplier for this artwork size (whole print pixels). */
    _printMultiplier() {
      return this._templateW / this._art.w;
    }

    _buildCanvas(overlayImg) {
      // The template loads async — the element may have been torn down
      // (theme editor re-render, navigation) while the request was in flight.
      if (this._destroyed || !this.isConnected) {
        log('build skipped: element torn down during template load');
        return;
      }
      var dims = this._computeCanvasSize();
      var canvasEl = document.createElement('canvas');
      this._stageEl.appendChild(canvasEl);

      var canvas = new window.fabric.Canvas(canvasEl, {
        width: dims.w,
        height: dims.h,
        backgroundColor: '#ffffff',   // the PRINT background (exported)
        selection: false,              // no multi-select / group transforms
        preserveObjectStacking: true,
        controlsAboveOverlay: true,
        enableRetinaScaling: true
      });

      // Artwork region inside the canvas — every placement/export references
      // this, and its aspect comes from the mockup's artwork rect.
      this._art = { x: dims.g, y: dims.g, w: dims.artW, h: dims.artH };

      overlayImg.set({ originX: 'left', originY: 'top', selectable: false, evented: false });
      this._mockupObj = overlayImg;
      canvas.overlayImage = overlayImg;
      this._positionMockup();
      canvas.requestRenderAll();

      this.czCanvas = canvas;
      this._canvasDims = dims;
      this._syncStageBox(dims);

      if (this._loadingEl) this._loadingEl.remove();
      this._stageEl.classList.add('mw-cz__case--ready');
      this._setStatus('');

      this._onResize = this._debounce(this._handleResize.bind(this), 250);
      // Both signals, debounced into one handler with a same-size guard:
      // ResizeObserver catches layout-driven changes; window resize is the
      // fallback where RO is missing or not delivering.
      window.addEventListener('resize', this._onResize);
      if (typeof ResizeObserver === 'function') {
        this._resizeObserver = new ResizeObserver(this._onResize);
        this._resizeObserver.observe(this._stageEl);
      }

      this._bindUI();
      this._initGuides();

      log('canvas ready', {
        template: this._templateW + 'x' + this._templateH,
        canvas: dims.w + 'x' + dims.h,
        dpr: window.devicePixelRatio
      });
      this.dispatchEvent(new CustomEvent('mw-cz:ready', { detail: this.czConfig }));
    }

    /* ---------------- Gate 5: photo upload + controls ---------------- */

    _bindUI() {
      var self = this;
      var canvas = this.czCanvas;
      this._photoBtn = this.querySelector('[data-mw-cz-tool="image"]');
      this._fileInput = this.querySelector('[data-mw-cz-file]');
      this._zoomWrap = this.querySelector('[data-mw-cz-zoom]');
      this._hintEl = this.querySelector('[data-mw-cz-hint]');

      if (this._photoBtn && this._fileInput) {
        this._photoBtn.disabled = false;
        this._photoBtn.addEventListener('click', function () {
          self._fileInput.click();
        });
        this._fileInput.addEventListener('change', function () {
          self._onPhotoPicked(self._fileInput);
        });
      }

      this._bindTextUI();

      var zoomIn = this.querySelector('[data-mw-cz-zoom-in]');
      var zoomOut = this.querySelector('[data-mw-cz-zoom-out]');
      if (zoomIn) zoomIn.addEventListener('click', function () { self._zoomActive(1.08); });
      if (zoomOut) zoomOut.addEventListener('click', function () { self._zoomActive(1 / 1.08); });

      // Wheel = fine zoom on the selected object (±1% per tick, spec §A8).
      canvas.on('mouse:wheel', function (opt) {
        if (!canvas.getActiveObject()) return;
        opt.e.preventDefault();
        opt.e.stopPropagation();
        self._zoomActive(opt.e.deltaY < 0 ? 1.01 : 1 / 1.01);
      });

      // Editing mode: workspace visible (no clip), guides on.
      // Idle mode: canvas clipped to the case silhouette — clean case view.
      // The mockup's opaque surround gives the clean case view at rest; on
      // selection it ghosts back so the customer can see what falls outside
      // the printed area, and the contextual controls swap in.
      var enterEditing = function () {
        self._stageEl.classList.add('is-editing');
        self._setGuidesVisible(true);
        self._setGhost(true);
        self._updateContextUI();
      };
      var leaveEditing = function () {
        self._stageEl.classList.remove('is-editing');
        self._setGuidesVisible(false);
        self._setGhost(false);
        self._updateContextUI();
      };
      canvas.on('selection:created', enterEditing);
      canvas.on('selection:updated', enterEditing);
      canvas.on('selection:cleared', leaveEditing);

      this._bindContextControls();
      this._bindTouchGestures();
      this._bindAddToCart();

      // Resolution guard: warn (never block) as the photo is resized.
      this._dpiEl = this.querySelector('[data-mw-cz-dpi]');
      var refreshDpi = function () { self._updateDpiWarning(); };
      canvas.on('object:scaling', refreshDpi);
      canvas.on('object:modified', refreshDpi);

      // Clicking anything that isn't the canvas deselects (spec §A8) —
      // Fabric only sees clicks on its own canvas, and <mw-customizer>
      // spans both columns, so "inside the element" is not a useful test.
      // Only the canvas itself and controls that ACT on the selection
      // (zoom buttons) preserve it.
      this._onDocPointerDown = function (e) {
        if (!self.czCanvas || !self.czCanvas.getActiveObject()) return;
        var t = e.target;
        if (t.closest && (t.closest('.canvas-container') || t.closest('[data-mw-cz-zoom]'))) return;
        self.czCanvas.discardActiveObject();
        self.czCanvas.requestRenderAll();
        leaveEditing();
      };
      document.addEventListener('pointerdown', this._onDocPointerDown);
    }

    /* ---------------- Gate 9: upload + add to cart ---------------- */

    _bindAddToCart() {
      var self = this;
      this._form = this.querySelector('[data-mw-cz-form]');
      this._atcBtn = this.querySelector('[data-mw-cz-atc]');
      this._busyEl = this.querySelector('[data-mw-cz-busy]');
      if (!this._form || !this._atcBtn) return;

      this._form.addEventListener('submit', function (e) {
        e.preventDefault();          // never let it navigate away
        self._addToCart();
      });

      // Rights confirmation: unticked by default, records the tick time.
      this._rightsBox = this.querySelector('[data-mw-cz-rights]');
      this._gateHintEl = this.querySelector('[data-mw-cz-gate-hint]');
      if (this._rightsBox) {
        this._rightsBox.checked = false;   // never restore a stale tick
        this._rightsBox.addEventListener('change', function () {
          self._rightsConfirmedAt = self._rightsBox.checked ? new Date().toISOString() : null;
          self._refreshAtcState();
        });
      }
      this._refreshAtcState();
    }

    /** ATC needs BOTH a design and the rights confirmation (Gate 10). */
    _refreshAtcState() {
      if (!this._atcBtn) return;
      var hasDesign = !!this._photoObj || !!this._textObj;
      var confirmed = !!this._rightsConfirmedAt;
      this._atcBtn.disabled = !hasDesign || !confirmed || !!this._saving;
      if (this._gateHintEl) {
        // Only nudge once they actually have something to add.
        this._gateHintEl.hidden = !(hasDesign && !confirmed && !this._saving);
      }
    }

    _setBusy(on, message) {
      this._saving = on;
      if (this._busyEl) {
        this._busyEl.hidden = !on;
        if (message) this._busyEl.textContent = message;
      }
      this.classList.toggle('is-saving', on);
      this._refreshAtcState();
    }

    _addToCart() {
      var self = this;
      if (this._saving) return;                       // double-tap guard
      if (!this._photoObj && !this._textObj) return;
      if (!this._rightsConfirmedAt) {                 // gate, belt and braces
        this._refreshAtcState();
        if (this._rightsBox) this._rightsBox.focus();
        return;
      }

      var ts = Date.now();
      var designId = 'mw-' + ts + '-' + Math.random().toString(36).slice(2, 8);

      this._setBusy(true, 'Preparing your design…');
      this._setStatus('');

      this.exportDesign()
        .then(function (out) {
          self._setBusy(true, 'Uploading your design…');
          return self._originalForUpload().then(function (original) {
            var fd = new FormData(self._form);   // variant id + visible properties

            fd.append('properties[_print_file]', out.print, 'print_' + ts + '.jpg');
            fd.append('properties[_preview_file]', out.preview, 'preview_' + ts + '.jpg');
            if (original) {
              fd.append('properties[_original_1]', original.blob, 'original_' + ts + '.' + original.ext);
            }
            fd.append('properties[_design_id]', designId);
            if (out.dpi !== null && out.dpi !== undefined) {
              fd.append('properties[_effective_dpi]', String(out.dpi));
            }
            if (out.previewAspect) {
              // Lets the cart reserve the right space before the image loads.
              fd.append('properties[_preview_ar]', out.previewAspect);
            }
            if (self._rightsConfirmedAt) {
              fd.append('properties[_rights_confirmed]', self._rightsConfirmedAt);
            }

            self._lastOriginalBytes = original ? original.blob.size : 0;

            // No Content-Type header — the browser must set the multipart boundary.
            return fetch(self._cartAddUrl(), { method: 'POST', body: fd })
              .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); });
          });
        })
        .then(function (res) {
          if (!res.ok || (res.json.status && res.json.status !== 200)) {
            throw new Error(res.json.description || res.json.message || 'Add to cart failed');
          }
          log('added to cart', res.json.items ? res.json.items[0] : res.json);
          self._afterAdd(res.json);
        })
        .catch(function (err) {
          log('add to cart failed', err);
          self._setStatus('Sorry — we could not add your design. Please try again.');
        })
        .finally(function () {
          self._setBusy(false);
        });
    }

    /** The raw original is kept so a bad print can be rebuilt by hand. But a
     *  DSLR JPEG can be 20–40MB: slow to upload on mobile data and liable to
     *  hit Shopify's per-file limit, which would fail the whole add-to-cart.
     *  Above the cap we upload the decoded, EXIF-corrected, template-sized
     *  copy instead — still a genuine archival source, a fraction of the size. */
    _originalForUpload() {
      var file = this._originalFile;
      if (!file) return Promise.resolve(null);

      var ext = String(file.name || 'original.jpg').split('.').pop().toLowerCase();
      if (file.size <= MAX_ORIGINAL_BYTES) {
        return Promise.resolve({ blob: file, ext: ext || 'jpg' });
      }

      var el = this._photoObj && this._photoObj.getElement && this._photoObj.getElement();
      if (!el || !el.width) {
        log('oversized original and no decoded copy available — uploading as is');
        return Promise.resolve({ blob: file, ext: ext || 'jpg' });
      }
      log('original too large, uploading decoded copy', {
        originalMB: (file.size / 1048576).toFixed(1),
        decoded: el.width + 'x' + el.height
      });
      return new Promise(function (resolve) {
        var cv = document.createElement('canvas');
        cv.width = el.width;
        cv.height = el.height;
        var ctx = cv.getContext('2d');
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, cv.width, cv.height);
        ctx.drawImage(el, 0, 0);
        cv.toBlob(function (blob) {
          resolve(blob ? { blob: blob, ext: 'jpg' } : { blob: file, ext: ext || 'jpg' });
        }, 'image/jpeg', 0.92);
      });
    }

    _cartAddUrl() {
      var base = (window.routes && window.routes.cart_add_url) || '/cart/add';
      return base.indexOf('.js') === -1 ? base + '.js' : base;
    }

    /** Refresh + open the existing cart drawer using its own public API —
     *  never touch its DOM directly (it owns the live Shiprocket node). */
    _afterAdd(cartJson) {
      try {
        // pubsub.js declares `publish` as a function (so it IS on window) but
        // constants.js declares PUB_SUB_EVENTS with `const`, which creates a
        // global lexical binding that is NOT on window. Reference both as
        // bare globals under typeof guards, or the publish silently no-ops.
        var pub = (typeof publish === 'function') ? publish : null;
        var events = (typeof PUB_SUB_EVENTS !== 'undefined') ? PUB_SUB_EVENTS : null;
        if (pub && events && events.cartUpdate) {
          pub(events.cartUpdate, {
            source: 'mw-customizer',
            productVariantId: this._form.querySelector('[name="id"]').value,
            cartData: cartJson
          });
        } else {
          log('pubsub unavailable — skipped cartUpdate');
        }
      } catch (err) {
        log('cartUpdate publish failed (non-fatal)', err);
      }

      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        drawer.renderContents(cartJson);   // V2: refresh + open, Shiprocket-safe
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
    }

    /* ---------------- Gate 8: export + resolution guard ---------------- */

    /** Effective print resolution of the customer's photo.
     *  The photo spans (sourcePx x scale x printMultiplier) pixels of the
     *  print file; the print file is authored at print_dpi, so the real
     *  resolution is print_dpi scaled by how far the source is stretched. */
    _effectiveDpi() {
      var p = this._photoObj;
      if (!p || !this._art) return null;
      var dpi = (this.czConfig && this.czConfig.print_dpi) || 300;
      var spread = p.scaleX * this._printMultiplier();
      if (!isFinite(spread) || spread <= 0) return null;
      return Math.round(dpi / spread);
    }

    _updateDpiWarning() {
      var el = this._dpiEl;
      if (!el) return;
      var dpi = this._effectiveDpi();
      this._lastDpi = dpi;
      el.classList.remove('is-amber', 'is-red');
      if (dpi === null || dpi >= 150) { el.hidden = true; return; }
      el.hidden = false;
      if (dpi < 100) {
        el.classList.add('is-red');
        el.textContent = 'This photo will print blurry at this size. Try a larger photo, or make it smaller on the case.';
      } else {
        el.classList.add('is-amber');
        el.textContent = 'This photo may print soft at this size. A larger photo would look sharper.';
      }
    }

    /** Renders a canvas region at an exact output size, flattened onto white
     *  (JPEG has no alpha — without this, transparent pixels turn black). */
    _renderRegion(region, outW, outH, quality) {
      var el = this.czCanvas.toCanvasElement(outW / region.w, {
        left: region.x, top: region.y, width: region.w, height: region.h
      });
      var out = document.createElement('canvas');
      out.width = outW;
      out.height = outH;
      var ctx = out.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, outW, outH);
      ctx.drawImage(el, 0, 0, outW, outH);
      return new Promise(function (resolve, reject) {
        out.toBlob(function (blob) {
          if (blob) resolve(blob); else reject(new Error('toBlob returned null'));
        }, 'image/jpeg', quality);
      });
    }

    /** Builds the print file and the preview.
     *  PRINT  = artwork region only, at the exact print dimensions, with the
     *           case mockup hidden — artwork only, nothing else (NBE spec).
     *  PREVIEW= the same design WITH the case, as the customer approved it.
     *  The overlay hide/show is wrapped in try/finally: if the export throws
     *  mid-way the case must never be left invisible on screen. */
    exportDesign() {
      var self = this;
      var canvas = this.czCanvas;
      var art = this._art;
      if (!canvas || !art) return Promise.reject(new Error('canvas not ready'));

      var printW = this._templateW;
      var printH = this._templateH;
      var ov = canvas.overlayImage;

      // No selection chrome, no guides in either file.
      canvas.discardActiveObject();
      this._setGuidesVisible(false);
      this._stageEl.classList.remove('is-editing');
      canvas.renderAll();

      var dpi = this._effectiveDpi();
      var result = {};

      return Promise.resolve()
        .then(function () {
          if (ov) ov.opacity = 0;          // step 2 — artwork only
          canvas.renderAll();
          return self._renderRegion(art, printW, printH, 0.94);
        })
        .then(function (blob) {
          result.print = blob;
        })
        .finally(function () {
          if (ov) ov.opacity = 1;          // step 4 — always restore
          canvas.renderAll();
        })
        .then(function () {
          // Preview covers the whole case, so use the mockup's own bounds.
          var region = ov ? {
            x: ov.left, y: ov.top,
            w: ov.width * ov.scaleX, h: ov.height * ov.scaleY
          } : art;
          var outH = 1300;
          var outW = Math.round(region.w / region.h * outH);
          result.previewAspect = (outW / outH).toFixed(4);
          return self._renderRegion(region, outW, outH, 0.9);
        })
        .then(function (blob) {
          result.preview = blob;
          result.dpi = dpi;
          result.printDimensions = printW + 'x' + printH;
          log('export complete', {
            print: Math.round(result.print.size / 1024) + 'KB',
            preview: Math.round(result.preview.size / 1024) + 'KB',
            dims: result.printDimensions,
            dpi: dpi
          });
          return result;
        });
    }

    /* ---------------- Gate 7: selection UI + touch ---------------- */

    _setGhost(on) {
      var ov = this.czCanvas && this.czCanvas.overlayImage;
      if (!ov) return;
      ov.opacity = on ? GHOST_OPACITY : 1;
      this.czCanvas.requestRenderAll();
    }

    _bindContextControls() {
      var self = this;
      this._contextEl = this.querySelector('[data-mw-cz-context]');
      this._contextLabel = this.querySelector('[data-mw-cz-context-label]');
      this._ctlEdit = this.querySelector('[data-mw-cz-ctl-edit]');
      if (!this._contextEl) return;

      var on = function (sel, fn) {
        var el = self.querySelector(sel);
        if (el) el.addEventListener('click', fn);
      };

      on('[data-mw-cz-ctl-edit]', function () { self._openTextModal(); });

      on('[data-mw-cz-ctl-centre]', function () {
        var obj = self.czCanvas.getActiveObject();
        if (!obj) return;
        var art = self._art;
        obj.setPositionByOrigin(
          new window.fabric.Point(art.x + art.w / 2, art.y + art.h / 2),
          'center', 'center'
        );
        obj.setCoords();
        self.czCanvas.requestRenderAll();
      });

      on('[data-mw-cz-ctl-straighten]', function () {
        var obj = self.czCanvas.getActiveObject();
        if (!obj) return;
        var centre = obj.getCenterPoint();
        obj.angle = 0;
        obj.setPositionByOrigin(centre, 'center', 'center');
        obj.setCoords();
        self.czCanvas.requestRenderAll();
      });

      on('[data-mw-cz-ctl-delete]', function () {
        var obj = self.czCanvas.getActiveObject();
        if (!obj) return;
        if (obj === self._textObj) {
          self._removeTextObject();
        } else if (obj === self._photoObj) {
          self.czCanvas.remove(obj);
          self._photoObj = null;
          self._originalFile = null;
          self._photoBtn.textContent = 'Add Photo';
          if (self._hintEl) self._hintEl.hidden = true;
          self._updateDpiWarning();
          self._refreshAtcState();
        } else {
          self.czCanvas.remove(obj);
        }
        self.czCanvas.discardActiveObject();
        self.czCanvas.requestRenderAll();
        self._setGuidesVisible(false);
        self._setGhost(false);
        self._stageEl.classList.remove('is-editing');
        self._updateContextUI();
      });
    }

    /** Contextual toolbar: hidden when nothing is selected; the Edit button
     *  exists for text only (spec §A8 — never for images). */
    _updateContextUI() {
      if (!this._contextEl) return;
      var obj = this.czCanvas ? this.czCanvas.getActiveObject() : null;
      var isText = !!obj && obj === this._textObj;
      this._contextEl.hidden = !obj;
      if (!obj) return;
      this._contextLabel.textContent = isText ? 'Text selected' : 'Photo selected';
      this._ctlEdit.hidden = !isText;
    }

    /** Two-finger pinch-to-zoom and twist-to-rotate. Fabric v6 has no
     *  multi-touch gestures, so this handles them directly on the canvas.
     *  Capture phase + preventDefault stops Fabric treating the second
     *  finger as a drag and stops the page pinch-zooming underneath. */
    _bindTouchGestures() {
      var self = this;
      var canvas = this.czCanvas;
      var el = canvas.upperCanvasEl;
      if (!el || !window.matchMedia) return;
      var start = null;

      var spread = function (t) {
        var dx = t[0].clientX - t[1].clientX;
        var dy = t[0].clientY - t[1].clientY;
        return { dist: Math.sqrt(dx * dx + dy * dy), angle: Math.atan2(dy, dx) * 180 / Math.PI };
      };

      var onStart = function (e) {
        if (e.touches.length !== 2) return;
        var obj = canvas.getActiveObject();
        if (!obj) return;
        var s = spread(e.touches);
        start = {
          dist: s.dist, angle: s.angle,
          scaleX: obj.scaleX, ratio: obj.scaleY / obj.scaleX, objAngle: obj.angle
        };
        e.preventDefault();
        e.stopPropagation();
      };

      var onMove = function (e) {
        if (!start || e.touches.length !== 2) return;
        var obj = canvas.getActiveObject();
        if (!obj) { start = null; return; }
        e.preventDefault();
        e.stopPropagation();

        var s = spread(e.touches);
        var isPhoto = obj === self._photoObj;
        var min = isPhoto ? self._coverScale * 0.25 : 0.05;
        var max = isPhoto ? self._coverScale * 5 : 20;
        var next = Math.min(max, Math.max(min, start.scaleX * (s.dist / start.dist)));
        var centre = obj.getCenterPoint();

        var turned = start.objAngle + (s.angle - start.angle);
        obj.scaleX = next;
        obj.scaleY = next * start.ratio;
        obj.angle = ((turned % 360) + 360) % 360;   // keep it 0–360, not -348
        obj.setPositionByOrigin(centre, 'center', 'center');
        obj.setCoords();
        canvas.requestRenderAll();
      };

      var onEnd = function (e) {
        if (e.touches.length < 2) start = null;
      };

      var opts = { passive: false, capture: true };
      el.addEventListener('touchstart', onStart, opts);
      el.addEventListener('touchmove', onMove, opts);
      el.addEventListener('touchend', onEnd, opts);
      el.addEventListener('touchcancel', onEnd, opts);
      this._touchTeardown = function () {
        el.removeEventListener('touchstart', onStart, opts);
        el.removeEventListener('touchmove', onMove, opts);
        el.removeEventListener('touchend', onEnd, opts);
        el.removeEventListener('touchcancel', onEnd, opts);
      };
    }

    /* ---------------- Gate 6: one text layer ---------------- */

    _bindTextUI() {
      var self = this;
      this._textBtn = this.querySelector('[data-mw-cz-tool="text"]');
      this._modal = this.querySelector('[data-mw-cz-modal]');
      if (!this._textBtn || !this._modal) return;

      this._textInput = this._modal.querySelector('[data-mw-cz-text-input]');
      this._textCount = this._modal.querySelector('[data-mw-cz-text-count]');
      this._fontsWrap = this._modal.querySelector('[data-mw-cz-fonts]');
      this._coloursWrap = this._modal.querySelector('[data-mw-cz-colours]');
      this._stylesWrap = this._modal.querySelector('[data-mw-cz-styles]');
      this._removeBtn = this._modal.querySelector('[data-mw-cz-text-remove]');

      this._draft = { font: FONTS[0], colour: COLOURS[0], style: STYLES[0] };

      this._buildFontChips();
      this._buildColourChips();
      this._buildStyleChips();

      this._textBtn.disabled = false;
      this._textBtn.addEventListener('click', function () { self._openTextModal(); });

      Array.prototype.forEach.call(
        this._modal.querySelectorAll('[data-mw-cz-modal-close]'),
        function (el) { el.addEventListener('click', function () { self._closeTextModal(); }); }
      );
      this._onModalKey = function (e) {
        if (e.key === 'Escape' && !self._modal.hidden) self._closeTextModal();
      };
      document.addEventListener('keydown', this._onModalKey);

      this._fontNote = this._modal.querySelector('[data-mw-cz-font-note]');

      this._textInput.addEventListener('input', function () { self._liveUpdate(); });

      this._modal.querySelector('[data-mw-cz-text-apply]')
        .addEventListener('click', function () { self._commitText(); });
      this._removeBtn.addEventListener('click', function () { self._removeText(); });
    }

    /** Enforces the 40-letter / 3-line limit. Letters are counted as
     *  graphemes so Tamil gets the same allowance as English and a letter
     *  is never cut in half. */
    _clampTextInput() {
      var v = this._textInput.value.replace(/\r/g, '');
      var lines = v.split('\n');
      if (lines.length > TEXT_MAX_LINES) {
        lines = lines.slice(0, TEXT_MAX_LINES);
        v = lines.join('\n');
      }
      if (countGraphemes(v) > TEXT_MAX_CHARS) v = sliceGraphemes(v, TEXT_MAX_CHARS);
      if (v !== this._textInput.value) this._textInput.value = v;
      return v;
    }

    /** A font without Tamil glyphs silently falls back to whatever font the
     *  customer's device has — and because the print file is rasterised on
     *  that device, the case would print in a typeface nobody chose. So when
     *  the text contains Tamil, non-Tamil fonts are locked out. */
    _syncFontAvailability() {
      var self = this;
      var hasTamil = TAMIL_RE.test(this._textInput.value);
      var switched = false;

      Array.prototype.forEach.call(this._fontsWrap.children, function (chip, i) {
        var font = FONTS[i];
        var blocked = hasTamil && !font.tamil;
        chip.disabled = blocked;
        chip.classList.toggle('is-unavailable', blocked);
        chip.title = blocked ? 'This font has no Tamil letters' : '';
      });

      if (hasTamil && this._draft.font && !this._draft.font.tamil) {
        for (var i = 0; i < FONTS.length; i++) {
          if (FONTS[i].tamil) {
            this._draft.font = FONTS[i];
            this._markChosen(this._fontsWrap, this._fontsWrap.children[i]);
            this._loadFont(FONTS[i]);
            switched = true;
            break;
          }
        }
      }

      if (this._fontNote) {
        this._fontNote.hidden = !hasTamil;
        this._fontNote.textContent = switched
          ? 'Switched to a Tamil font — the other fonts have no Tamil letters.'
          : 'Only Tamil-capable fonts are shown for Tamil text.';
      }
      return hasTamil;
    }

    _buildFontChips() {
      var self = this;
      this._fontsWrap.innerHTML = '';
      FONTS.forEach(function (font, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mw-cz-chip mw-cz-chip--font';
        b.setAttribute('role', 'radio');
        b.style.fontFamily = "'" + font.css + "', sans-serif";
        b.style.fontWeight = font.weight;
        b.textContent = font.label;
        if (font.tamil) {
          var tag = document.createElement('span');
          tag.className = 'mw-cz-chip__tag';
          tag.textContent = 'தமிழ்';
          b.appendChild(tag);
        }
        b.addEventListener('click', function () {
          self._draft.font = font;
          self._markChosen(self._fontsWrap, b);
          self._loadFont(font).then(function () { self._liveUpdate(); });
          self._liveUpdate();
        });
        b.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
        if (i === 0) b.classList.add('is-chosen');
        self._fontsWrap.appendChild(b);
      });
    }

    _buildColourChips() {
      var self = this;
      this._coloursWrap.innerHTML = '';
      COLOURS.forEach(function (colour, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mw-cz-swatch';
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-label', colour);
        b.style.background = colour;
        b.addEventListener('click', function () {
          self._draft.colour = colour;
          self._markChosen(self._coloursWrap, b);
          self._liveUpdate();
        });
        b.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
        if (i === 0) b.classList.add('is-chosen');
        self._coloursWrap.appendChild(b);
      });
    }

    _buildStyleChips() {
      var self = this;
      this._stylesWrap.innerHTML = '';
      STYLES.forEach(function (style, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'mw-cz-chip';
        b.setAttribute('role', 'radio');
        b.textContent = style.label;
        b.addEventListener('click', function () {
          self._draft.style = style;
          self._markChosen(self._stylesWrap, b);
          self._liveUpdate();
        });
        b.setAttribute('aria-checked', i === 0 ? 'true' : 'false');
        if (i === 0) b.classList.add('is-chosen');
        self._stylesWrap.appendChild(b);
      });
    }

    _markChosen(wrap, el) {
      Array.prototype.forEach.call(wrap.children, function (c) {
        c.classList.toggle('is-chosen', c === el);
        c.setAttribute('aria-checked', c === el ? 'true' : 'false');
      });
    }

    /** Canvas needs the font actually loaded before it can rasterise it. */
    _loadFont(font) {
      if (!font || !document.fonts || !document.fonts.load) return Promise.resolve();
      var spec = font.weight + ' 48px "' + font.css + '"';
      return document.fonts.load(spec, 'Aa அஆஇ').catch(function (err) {
        log('font load failed', font.css, err);
      });
    }

    _openTextModal() {
      var self = this;
      var existing = this._textObj;
      if (existing) {
        this._textInput.value = existing.text || '';
        this._draft = {
          font: this._fontByCss(existing.fontFamily) || FONTS[0],
          colour: existing._mwColour || COLOURS[0],
          style: this._styleById(existing._mwStyleId) || STYLES[0]
        };
      } else {
        this._textInput.value = '';
        this._draft = { font: FONTS[0], colour: COLOURS[0], style: STYLES[0] };
      }
      this._syncChips();
      this._textCount.textContent = String(countGraphemes(this._textInput.value));
      this._syncFontAvailability();
      this._removeBtn.hidden = !existing;
      this._textSnapshot = this._snapshotText();
      this._modal.hidden = false;
      document.body.classList.add('mw-cz-modal-open');
      // Preload the chosen font while the customer types.
      this._loadFont(this._draft.font);
      setTimeout(function () { self._textInput.focus(); }, 30);
    }

    /** commit=false (✕ / Escape / backdrop) undoes the live edits. */
    _closeTextModal(commit) {
      if (!commit) this._restoreText(this._textSnapshot);
      this._textSnapshot = null;
      this._modal.hidden = true;
      document.body.classList.remove('mw-cz-modal-open');
    }

    _syncChips() {
      var self = this;
      var mark = function (el, on) {
        el.classList.toggle('is-chosen', on);
        el.setAttribute('aria-checked', on ? 'true' : 'false');
      };
      Array.prototype.forEach.call(this._fontsWrap.children, function (c, i) {
        mark(c, FONTS[i] === self._draft.font);
      });
      Array.prototype.forEach.call(this._coloursWrap.children, function (c, i) {
        mark(c, COLOURS[i] === self._draft.colour);
      });
      Array.prototype.forEach.call(this._stylesWrap.children, function (c, i) {
        mark(c, STYLES[i] === self._draft.style);
      });
    }

    _fontByCss(css) {
      for (var i = 0; i < FONTS.length; i++) if (FONTS[i].css === css) return FONTS[i];
      return null;
    }

    _styleById(id) {
      for (var i = 0; i < STYLES.length; i++) if (STYLES[i].id === id) return STYLES[i];
      return null;
    }

    /** Live preview: every keystroke and option change renders on the case
     *  immediately. The font may still be downloading on first use, so we
     *  draw straight away and redraw once it resolves. */
    _liveUpdate() {
      var self = this;
      var value = this._clampTextInput();
      this._textCount.textContent = String(countGraphemes(value));
      this._syncFontAvailability();

      var trimmed = value.trim();
      if (!trimmed) {
        if (this._textObj) {
          this._textObj.visible = false;
          this.czCanvas.requestRenderAll();
        }
        return;
      }

      this._renderText(trimmed, false);
      var font = this._draft.font || FONTS[0];
      if (!document.fonts || !document.fonts.check ||
          !document.fonts.check(font.weight + ' 48px "' + font.css + '"', trimmed)) {
        this._loadFont(font).then(function () {
          if (self._destroyed || self._modal.hidden) return;
          var latest = self._textInput.value.trim();
          if (latest) self._renderText(latest, false);
        });
      }
    }

    /** Update = keep what's on the case and close. */
    _commitText() {
      var value = this._clampTextInput().trim();
      if (!value) return this._removeText();
      this._renderText(value, true);
      this._closeTextModal(true);
    }

    /** Snapshot so ✕ / Escape / backdrop can undo the live edits. */
    _snapshotText() {
      var t = this._textObj;
      if (!t) return { existed: false };
      return {
        existed: true, visible: t.visible, text: t.text,
        fontFamily: t.fontFamily, fontWeight: t.fontWeight, fontSize: t.fontSize,
        fill: t.fill, stroke: t.stroke, strokeWidth: t.strokeWidth,
        charSpacing: t.charSpacing, shadow: t.shadow,
        left: t.left, top: t.top, scaleX: t.scaleX, scaleY: t.scaleY, angle: t.angle,
        colour: t._mwColour, styleId: t._mwStyleId
      };
    }

    _restoreText(snap) {
      var canvas = this.czCanvas;
      if (!snap || !snap.existed) {
        if (this._textObj) {
          canvas.remove(this._textObj);
          this._textObj = null;
          this._textBtn.textContent = 'Add Text';
        }
      } else if (this._textObj) {
        this._textObj.set({
          visible: snap.visible, text: snap.text,
          fontFamily: snap.fontFamily, fontWeight: snap.fontWeight, fontSize: snap.fontSize,
          fill: snap.fill, stroke: snap.stroke, strokeWidth: snap.strokeWidth,
          charSpacing: snap.charSpacing, shadow: snap.shadow,
          left: snap.left, top: snap.top, scaleX: snap.scaleX, scaleY: snap.scaleY, angle: snap.angle
        });
        this._textObj._mwColour = snap.colour;
        this._textObj._mwStyleId = snap.styleId;
        this._textObj.setCoords();
      }
      canvas.requestRenderAll();
    }

    /** V1: ONE text layer — created once, then updated in place.
     *  `select` is false during live typing so focus stays in the textarea. */
    _renderText(value, select) {
      var canvas = this.czCanvas;
      var art = this._art;
      var font = this._draft.font || FONTS[0];
      var style = this._draft.style || STYLES[0];
      var obj = this._textObj;

      // Size relative to the artwork so it scales with the canvas.
      var fontSize = obj ? obj.fontSize : Math.round(art.w * 0.11);

      var props = {
        text: value,
        fontFamily: font.css,
        fontWeight: font.weight,
        fill: this._draft.colour,
        textAlign: 'center',
        stroke: style.stroke || null,
        strokeWidth: style.strokeWidth ? style.strokeWidth * fontSize : 0,
        paintFirst: 'stroke',
        charSpacing: style.charSpacing || 0,
        shadow: style.shadow || null,
        strokeUniform: true
      };

      if (!obj) {
        // fabric.Text (not IText): no in-canvas typing, modal only.
        obj = new window.fabric.Text(value, Object.assign({
          originX: 'center',
          originY: 'center',
          left: art.x + art.w / 2,
          top: art.y + art.h * 0.78,
          fontSize: fontSize
        }, props));
        this._applyControlStyle(obj);
        obj.clipPath = this._artClip();
        canvas.add(obj);
        this._textObj = obj;
      } else {
        obj.set(props);
        obj.visible = true;
      }
      obj._mwColour = this._draft.colour;
      obj._mwStyleId = style.id;
      obj._mwIsText = true;

      canvas.bringObjectToFront(obj);   // text always above the photo
      this._bringGuidesToFront();
      obj.setCoords();
      if (select) canvas.setActiveObject(obj);
      canvas.requestRenderAll();

      this._textBtn.textContent = 'Edit Text';
      if (this._zoomWrap) this._zoomWrap.hidden = false;
      this._refreshAtcState();
      log('text applied', { chars: value.length, font: font.css, style: style.id });
    }

    _removeTextObject() {
      if (this._textObj) {
        this.czCanvas.remove(this._textObj);
        this._textObj = null;
        this.czCanvas.requestRenderAll();
      }
      this._textBtn.textContent = 'Add Text';
      this._refreshAtcState();
    }

    _removeText() {
      this._removeTextObject();
      this._closeTextModal(true);
    }

    _onPhotoPicked(input) {
      var file = input.files && input.files[0];
      input.value = ''; // allow re-picking the same file
      if (!file) return;

      var problem = this._validatePhotoFile(file);
      if (problem) return this._setStatus(problem);

      var self = this;
      this._setStatus('Adding your photo…');
      this._decodePhoto(file)
        .then(function (canvasEl) {
          if (self._destroyed) return;
          self._originalFile = file; // kept for the _original_1 upload at Gate 9
          self._placePhoto(canvasEl);
          self._setStatus('');
        })
        .catch(function (err) {
          log('photo decode failed', err);
          self._setStatus('Could not read that photo. Please try a different JPG or PNG.');
        });
    }

    _validatePhotoFile(file) {
      var name = String(file.name || '').toLowerCase();
      var type = String(file.type || '').toLowerCase();
      if (type === 'image/heic' || type === 'image/heif' || /\.hei[cf]$/.test(name)) {
        return 'iPhone photos need to be JPG. Open the photo → Share → Save to Files → choose JPEG, or take a screenshot of it and upload that.';
      }
      var okType = ['image/jpeg', 'image/png', 'image/webp'].indexOf(type) !== -1;
      var okExt = /\.(jpe?g|png|webp)$/.test(name);
      if (!okType && !okExt) return 'Please choose a JPG, PNG or WebP photo.';
      return null;
    }

    /** Decodes with EXIF orientation applied, downscaled so the longest side
     *  never exceeds the template's longest side. Always returns a canvas. */
    _decodePhoto(file) {
      var maxSide = Math.max(this._templateW, this._templateH);
      var toCanvas = function (source, sw, sh) {
        var scale = Math.min(1, maxSide / Math.max(sw, sh));
        var cv = document.createElement('canvas');
        cv.width = Math.max(1, Math.round(sw * scale));
        cv.height = Math.max(1, Math.round(sh * scale));
        cv.getContext('2d').drawImage(source, 0, 0, cv.width, cv.height);
        return cv;
      };
      var viaImg = function () {
        return new Promise(function (resolve, reject) {
          var url = URL.createObjectURL(file);
          var img = new Image();
          img.onload = function () {
            // Browsers apply EXIF orientation to <img> decode by default.
            var cv = toCanvas(img, img.naturalWidth, img.naturalHeight);
            URL.revokeObjectURL(url);
            resolve(cv);
          };
          img.onerror = function (e) {
            URL.revokeObjectURL(url);
            reject(e);
          };
          img.src = url;
        });
      };
      if (typeof createImageBitmap === 'function') {
        return createImageBitmap(file, { imageOrientation: 'from-image' })
          .then(function (bmp) {
            var cv = toCanvas(bmp, bmp.width, bmp.height);
            bmp.close();
            return cv;
          })
          .catch(viaImg);
      }
      return viaImg();
    }

    /** V1: ONE photo. Placing again replaces the previous one.
     *  Cover-fit + centre so the initial composition needs no adjustment. */
    _placePhoto(el) {
      var canvas = this.czCanvas;
      if (this._photoObj) {
        canvas.remove(this._photoObj);
        this._photoObj = null;
      }
      var art = this._art;
      var img = new window.fabric.FabricImage(el);
      var cover = Math.max(art.w / img.width, art.h / img.height);
      img.set({
        originX: 'center',
        originY: 'center',
        left: art.x + art.w / 2,
        top: art.y + art.h / 2,
        scaleX: cover,
        scaleY: cover
      });
      this._applyControlStyle(img);
      img.clipPath = this._artClip();
      this._coverScale = cover;

      canvas.add(img);
      canvas.sendObjectToBack(img);   // photo is always the bottom layer
      if (this._textObj) canvas.bringObjectToFront(this._textObj);
      this._bringGuidesToFront();
      canvas.setActiveObject(img);
      canvas.requestRenderAll();
      this._photoObj = img;

      if (this._photoBtn) this._photoBtn.textContent = 'Replace Photo';
      if (this._zoomWrap) this._zoomWrap.hidden = false;
      if (this._hintEl) this._hintEl.hidden = false;
      this._updateDpiWarning();
      this._refreshAtcState();
      log('photo placed', { natural: img.width + 'x' + img.height, cover: cover.toFixed(4) });
    }

    _applyControlStyle(obj) {
      var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
      obj.set({
        cornerStyle: 'circle',
        cornerColor: '#111111',
        cornerStrokeColor: '#ffffff',
        transparentCorners: false,
        borderColor: '#111111',
        cornerSize: coarse ? 28 : 22,   // >=24px touch targets on mobile
        touchCornerSize: 44,
        lockScalingFlip: true,
        lockSkewingX: true,
        lockSkewingY: true,
        centeredScaling: true,
        centeredRotation: true
      });
      obj.setControlsVisibility({ ml: false, mt: false, mr: false, mb: false });
    }

    _zoomActive(factor) {
      var canvas = this.czCanvas;
      if (!canvas) return;
      var obj = canvas.getActiveObject() || this._photoObj;
      if (!obj) return;
      var isPhoto = obj === this._photoObj;
      var min = isPhoto ? this._coverScale * 0.25 : 0.2;
      var max = isPhoto ? this._coverScale * 5 : 10;
      var ratio = obj.scaleY / obj.scaleX;
      var s = Math.min(max, Math.max(min, obj.scaleX * factor));
      var centre = obj.getCenterPoint();
      obj.scaleX = s;
      obj.scaleY = s * ratio;
      obj.setPositionByOrigin(centre, 'center', 'center');
      obj.setCoords();
      canvas.requestRenderAll();
      this._updateDpiWarning();
    }

    /* ------------- safe-area / camera guides (template-derived) ------------- */

    /** Guides derive from the mask asset's pixels — nothing hard-coded.
     *  They are UI-only: excludeFromExport keeps them out of every export. */
    _initGuides() {
      var self = this;
      if (!this.czConfig || !this.czConfig.mask_src) return;
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        var geom = null;
        try {
          geom = self._scanMask(img);
        } catch (err) {
          log('guide scan failed', err);
        }
        // Browsers with canvas-read protection (e.g. Edge strict tracking
        // prevention) return noisy/garbage pixel data — a corrupt scan puts
        // the bezel and clip in the wrong place. Sanity-check the geometry
        // and fall back to the known case-window fractions (UI-only values;
        // never used in print/export math).
        if (!self._geomLooksSane(geom)) {
          log('mask scan implausible, using fallback UI geometry', geom);
          geom = {
            sil: { x0: 0.0922, y0: 0, x1: 0.9078, y1: 1 },
            cam: { x0: 0.112, y0: 0.008, x1: 0.529, y1: 0.265 },
            radius: 0.137
          };
        }
        self._guideGeom = geom;
        self._createGuides();
      };
      img.onerror = function () { log('mask load failed (guides skipped)'); };
      img.src = this.czConfig.mask_src;
    }

    _geomLooksSane(g) {
      if (!g || !g.sil) return false;
      var s = g.sil;
      var symmetric = Math.abs((1 - s.x1) - s.x0) < 0.05;
      return s.y0 < 0.03 && s.y1 > 0.97 &&
        s.x0 > 0.04 && s.x0 < 0.2 && symmetric &&
        g.radius > 0.02 && g.radius < 0.25 &&
        (!g.cam || (g.cam.x1 < 0.65 && g.cam.y1 < 0.4));
    }

    /** Downsamples the silhouette mask and measures, as fractions of the
     *  template: the printable bbox, its corner radius, and the enclosed
     *  camera cutout (found as the transparent region NOT connected to the
     *  outside — corners flood away, the camera hole remains). */
    _scanMask(img) {
      var W = 120;
      var H = Math.max(2, Math.round(W * img.height / img.width));
      var cv = document.createElement('canvas');
      cv.width = W; cv.height = H;
      var ctx = cv.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, W, H);
      var d = ctx.getImageData(0, 0, W, H).data;
      var isIn = function (x, y) { return d[(y * W + x) * 4] > 127; };

      var x0 = W, y0 = H, x1 = -1, y1 = -1, x, y;
      for (y = 0; y < H; y++) {
        for (x = 0; x < W; x++) {
          if (isIn(x, y)) {
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
          }
        }
      }
      if (x1 < 0) throw new Error('mask empty');

      // flood the OUTSIDE over non-printable cells, starting from the borders
      var out = new Uint8Array(W * H);
      var stack = [];
      var push = function (px, py) {
        var i = py * W + px;
        if (px < 0 || py < 0 || px >= W || py >= H) return;
        if (out[i] || isIn(px, py)) return;
        out[i] = 1;
        stack.push(px, py);
      };
      for (x = 0; x < W; x++) { push(x, 0); push(x, H - 1); }
      for (y = 0; y < H; y++) { push(0, y); push(W - 1, y); }
      while (stack.length) {
        var cy = stack.pop(), cx = stack.pop();
        push(cx + 1, cy); push(cx - 1, cy); push(cx, cy + 1); push(cx, cy - 1);
      }

      var cx0 = W, cy0 = H, cx1 = -1, cy1 = -1, camCells = 0;
      for (y = 0; y < H; y++) {
        for (x = 0; x < W; x++) {
          if (!isIn(x, y) && !out[y * W + x]) {
            camCells += 1;
            if (x < cx0) cx0 = x;
            if (x > cx1) cx1 = x;
            if (y < cy0) cy0 = y;
            if (y > cy1) cy1 = y;
          }
        }
      }

      // corner radius ~ inset of the first printable pixel on the top row
      var lx = x1;
      for (x = x0; x <= x1; x++) { if (isIn(x, y0)) { lx = x; break; } }

      return {
        sil: { x0: x0 / W, y0: y0 / H, x1: (x1 + 1) / W, y1: (y1 + 1) / H },
        cam: camCells > 4
          ? { x0: cx0 / W, y0: cy0 / H, x1: (cx1 + 1) / W, y1: (cy1 + 1) / H }
          : null,
        radius: Math.max(0, (lx - x0) / W)
      };
    }

    _createGuides() {
      var g = this._guideGeom;
      var canvas = this.czCanvas;
      var art = this._art;
      if (!g || !canvas || !art) return;
      var mk = function (b, radiusFrac) {
        return new window.fabric.Rect({
          left: art.x + b.x0 * art.w,
          top: art.y + b.y0 * art.h,
          width: (b.x1 - b.x0) * art.w,
          height: (b.y1 - b.y0) * art.h,
          rx: radiusFrac * art.w,
          ry: radiusFrac * art.w,
          fill: '',
          stroke: '#111111',
          strokeDashArray: [6, 5],
          strokeWidth: 1.5,
          strokeUniform: true,
          opacity: 0.55,
          originX: 'left',
          originY: 'top',
          selectable: false,
          evented: false,
          excludeFromExport: true,
          visible: false
        });
      };
      // One safe-area line, inset inside the glass so it reads against the
      // photo (the mockup itself already shows the case edge and camera).
      var inset = (g.sil.x1 - g.sil.x0) * 0.045;
      this._guides = [mk({
        x0: g.sil.x0 + inset,
        y0: g.sil.y0 + inset * (art.w / art.h),
        x1: g.sil.x1 - inset,
        y1: g.sil.y1 - inset * (art.w / art.h)
      }, Math.max(0, g.radius - inset))];
      var self = this;
      this._guides.forEach(function (guide) { self.czCanvas.add(guide); });
      this._bringGuidesToFront();
    }

    _bringGuidesToFront() {
      var canvas = this.czCanvas;
      if (!canvas || !this._guides) return;
      this._guides.forEach(function (guide) { canvas.bringObjectToFront(guide); });
    }

    _setGuidesVisible(visible) {
      var canvas = this.czCanvas;
      if (!canvas || !this._guides) return;
      this._guides.forEach(function (guide) { guide.visible = visible; });
      if (visible) this._bringGuidesToFront();
      canvas.requestRenderAll();
    }

    _handleResize() {
      var canvas = this.czCanvas;
      if (!canvas || !this._canvasDims || !this._art) return;
      var dims = this._computeCanvasSize();
      if (!dims.h || (dims.w === this._canvasDims.w && dims.h === this._canvasDims.h)) return;
      var oldArt = this._art;
      var newArt = { x: dims.g, y: dims.g, w: dims.artW, h: dims.artH };
      var factor = newArt.w / oldArt.w;
      // If the canvas was built while unmeasurable (0-size), factor is
      // Infinity/NaN — resizing is fine, but rescaling objects by it would
      // destroy the design. Size the canvas and skip object rescale.
      var rescaleObjects = isFinite(factor) && factor > 0;

      canvas.setDimensions({ width: dims.w, height: dims.h });
      this._art = newArt;
      this._positionMockup();

      var decor = (this._guides || []).slice();
      if (rescaleObjects) {
        // Transform CONTENT relative to the ARTWORK region — the gutter is
        // clamped, not proportional, so canvas-relative scaling would drift.
        // Guides are rebuilt from geometry instead.
        canvas.getObjects().forEach(function (obj) {
          if (decor.indexOf(obj) !== -1) return;
          obj.set({
            left: newArt.x + (obj.left - oldArt.x) * factor,
            top: newArt.y + (obj.top - oldArt.y) * factor,
            scaleX: obj.scaleX * factor,
            scaleY: obj.scaleY * factor
          });
          obj.setCoords();
        });
        this._coverScale = (this._coverScale || 1) * factor;
      } else {
        log('object rescale skipped (previous size was 0)');
      }

      var self = this;
      canvas.getObjects().forEach(function (obj) {
        if (obj.clipPath && obj.clipPath.absolutePositioned) obj.clipPath = self._artClip();
      });

      this._canvasDims = dims;
      this._syncStageBox(dims);
      this._rebuildDecor();
      canvas.requestRenderAll();
      log('resized canvas', dims);
    }

    /** Removes and re-creates guides from geometry at the current artwork
     *  size — deterministic, no incremental-transform drift. */
    _rebuildDecor() {
      var canvas = this.czCanvas;
      if (!canvas) return;
      var guidesWereVisible = !!(this._guides && this._guides.some(function (g) { return g.visible; }));
      if (this._guides) {
        this._guides.forEach(function (g) { canvas.remove(g); });
        this._guides = null;
      }
      if (this._guideGeom) {
        this._createGuides();
        if (guidesWereVisible) this._setGuidesVisible(true);
      }
    }

    _debounce(fn, ms) {
      var t = null;
      return function () {
        clearTimeout(t);
        t = setTimeout(fn, ms);
      };
    }

    disconnectedCallback() {
      this._destroyed = true;
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._onDocPointerDown) {
        document.removeEventListener('pointerdown', this._onDocPointerDown);
        this._onDocPointerDown = null;
      }
      if (this._onModalKey) {
        document.removeEventListener('keydown', this._onModalKey);
        this._onModalKey = null;
      }
      if (this._touchTeardown) {
        this._touchTeardown();
        this._touchTeardown = null;
      }
      document.body.classList.remove('mw-cz-modal-open');
      if (this.czCanvas) {
        this.czCanvas.dispose();
        this.czCanvas = null;
      }
    }

    _setStatus(msg) {
      if (this._statusEl) this._statusEl.textContent = msg || '';
    }

    _fail(msg) {
      this._setStatus(msg);
      this.classList.add('mw-cz--error');
      if (this._loadingEl) this._loadingEl.textContent = msg;
      var atc = this.querySelector('[data-mw-cz-atc]');
      if (atc) atc.disabled = true;
    }
  }

  customElements.define('mw-customizer', MWCustomizer);
})();
